import { useFormContext } from 'react-hook-form';

import VNPortlet from '../VNPortlet/VNPortlet';
import VNToggle from '../VNToggle/VNToggle';
import { EFFECT_OPTIONS } from './GeoblockConstants';

type Props = {
  name: string;
};

const GeoblockDefaultAvailability = ({ name }: Props) => {
  const { watch } = useFormContext();
  const defaultEffect = watch(`${name}.defaultEffect`);

  return (
    <div className="geoblock-default-availability">
      <VNPortlet
        title={
          <div className="portlet-title">
            <span className="step-number">1</span>
            Select Availability
          </div>
        }
      >
        <div>
          <div className="availability-toggle">
            <VNToggle name={`${name}.defaultEffect`} options={EFFECT_OPTIONS} label="defaultLabel" />
          </div>
          <div className="availability-description">
            {EFFECT_OPTIONS.find((option) => option.value === defaultEffect)?.helpText}
          </div>
          <div className="availability-subtitle">
            More specific rules override broader rules (ZIP &rarr; City &rarr; DMA &rarr; State &rarr; Country)
          </div>
        </div>
      </VNPortlet>
    </div>
  );
};

export default GeoblockDefaultAvailability;
